import type { ReactNode } from 'react';

export const symbol_ad_group_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M880-820v589q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-529H297q-12.44 0-23.72-5T254-778l-53-53q4-21 20.5-35t38.5-14h560q24.75 0 42.38 17.62Q880-844.75 880-820ZM260-200q-24.75 0-42.37-17.63Q200-235.25 200-260v-403L49.97-813.03Q41-822 41-834q0-12 9-21t21-9q12 0 21 9L855-92q9 9 9 21t-9 21q-9 9-21 9t-20.97-8.97L663-200H260Zm0-60h343L260-603v343ZM140-80q-24.75 0-42.37-17.63Q80-115.25 80-140v-590q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v590h590q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q742.75-80 730-80H140Zm293-349Zm107-87Z"
		/>
	</svg>
);
